import { render } from "./DigitalLearningEcosystemView.vue?vue&type=template&id=38f84967&scoped=true"
import script from "./DigitalLearningEcosystemView.vue?vue&type=script&lang=js"
export * from "./DigitalLearningEcosystemView.vue?vue&type=script&lang=js"

import "./DigitalLearningEcosystemView.vue?vue&type=style&index=0&id=38f84967&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f84967"]])

export default __exports__